import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import { isMobile } from 'react-device-detect';
import {
  Stack,
  Typography,
  Card,
  Button,
  TextField,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Autocomplete,
  Tab
} from '@mui/material';

import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import configAxios from '../../../../services/configAxios';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';

import AddEditDayTerm from './addEditDayTerm';

import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';

import MoreMenu from '../../../components/multiplesComponents/MoreMenu';

const addEditTerms = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { state, pathname } = location;
  const pathNameSplice = pathname.split('/');
  const [infosTerms, setInfosTerms] = useState(state ? { ...state.infosEdit } : {});
  const [infosRegioes, setInfosRegioes] = useState([]);
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  const [openModalDay, setOpenModalDay] = useState(false);
  const [infosDaysTerms, setInfosDaysTerms] = useState([]);
  const [infosTypesOfHiring, setInfosTypesOfHiring] = useState([]);
  const [value, setValue] = useState('1');

  const allowedPageSizes = [5, 10, 20, 30];

  useEffect(() => {
    if (state === null && pathNameSplice[2] === 'editTerm') [navigation('/app/terms')];
    if (infoState.controlaregiao === 'Sim') {
      getRegioes();
    }
    if (infosTerms.id) {
      getDaysTerms();
    }
    getTypesOfHiring();
  }, []);

  function getRegioes() {
    configAxios
      .get('/products/getRegioesLabel')
      .then((response) => {
        // console.log(response.data);
        setInfosRegioes(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar as vigências no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  function getDaysTerms() {
    configAxios
      .get(`/terms/daysOfTerm?tpcontrat=${infosTerms.tpcontrat}&id_regiao=${infosTerms.id_regiao}`)
      .then((response) => {
        // console.log(response.data);
        setInfosDaysTerms(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar as vigências no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleInputChange(event, autocomplete) {
    if (autocomplete) {
      if (event) {
        setInfosTerms({
          ...infosTerms,
          label: event.label,
          id_regiao: event.idregiao
        });
        return;
      }
      return;
    }
    setInfosTerms({ ...infosTerms, [event.target.name]: event.target.value });
  }

  function HandleSubmit(event) {
    event.preventDefault();
    const router = infosTerms.id ? '/terms/updateTerm' : '/terms/addTerm';
    configAxios
      .post(router, infosTerms)
      .then((response) => {
        const message = infosTerms.id
          ? 'Vigência atualizada com sucesso!'
          : 'Vigência inserida com sucesso!';

        NotificationManager.success(message, 'Sucesso');

        setInfosTerms({
          ...infosTerms,
          id: response.data.id,
          codplano: response.data.codplano
        });

        const nav = infosTerms.id
          ? `/app/editTerm/${infosTerms.id}`
          : `/app/editTerm/${response.data.id}`;

        navigation(nav, {
          state: {
            infosEdit: {
              ...infosTerms,
              id: infosTerms.id ? infosTerms.id : response.data.id
            }
          }
        });
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function handleTabsChange(event, newValue) {
    setValue(newValue);
  }

  function termModalDay() {
    setOpenModalDay(true);
  }

  function ActionsButtonsDayOfTerm(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          deleteRouter: '/terms/deleteDayOfTerm',
          deleteItem: 'o dia de vigência',
          functionGrid: getDaysTerms,
          disabledEdit: true,
          otherInfos: item
        }}
      />
    ));
  }

  async function getTypesOfHiring() {
    configAxios
      .get(`/config/getTypesOfHiring`)
      .then((response) => {
        setInfosTypesOfHiring(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar os tipos de contratação no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  return (
    <RenderPage title="Vigências" id="terms">
      <>
        <AddEditDayTerm
          openModal={openModalDay}
          setOpenModal={setOpenModalDay}
          functionGrid={getDaysTerms}
          otherInfos={infosTerms}
        />
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Cadastro de vigências
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo para inserir e editar as vigências
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            {!isMobile && (
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/terms"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <form onSubmit={HandleSubmit}>
              <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 2 }}>
                <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  {infosTerms.id && (
                    <Grid item xs={3} md={1}>
                      <TextField
                        name="id"
                        fullWidth
                        label="ID"
                        variant="outlined"
                        size="small"
                        required
                        value={infosTerms.id || ''}
                        disabled
                      />
                    </Grid>
                  )}
                </Grid>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  {infoState.controlaregiao === 'Sim' && (
                    <Grid item xs={12} md={3}>
                      <Autocomplete
                        options={infosRegioes}
                        renderOption={(props, option) => <li {...props}>{option.label}</li>}
                        isOptionEqualToValue={(option, value) =>
                          value ? option.label === value : option.label === ''
                        }
                        onChange={(event, value) =>
                          HandleInputChange(value, { autocomplete: true })
                        }
                        value={infosTerms.label || ''}
                        defaultValue=""
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Região"
                            name="id_regiao"
                            fullWidth
                            size="small"
                            variant="outlined"
                            required
                          />
                        )}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} md={3}>
                    <InputLabel
                      id="label"
                      sx={isMobile ? { mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                      Tipo de contratação *
                    </InputLabel>
                    <Select
                      name="tpcontrat"
                      fullWidth
                      size="small"
                      required
                      value={infosTerms.tpcontrat || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {/* <MenuItem value={'1-INDIVIDUAL/FAMILIAR'}>1-INDIVIDUAL/FAMILIAR</MenuItem>
                      <MenuItem value={'2-COLETIVO EMPRESARIAL'}>2-COLETIVO EMPRESARIAL</MenuItem>
                      <MenuItem value={'3-COLETIVO POR ADESAO'}>3-COLETIVO POR ADESÃO</MenuItem> */}
                      {infosTypesOfHiring.map((item) => (
                        <MenuItem key={item.id} value={item.tpcontrat}>
                          {item.tpcontrat}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <InputLabel id="label" sx={{ mt: -2.2, fontSize: '13px' }}>
                      Status *
                    </InputLabel>
                    <Select
                      name="status"
                      fullWidth
                      size="small"
                      required
                      value={infosTerms.status || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      <MenuItem value={'ATIVO'}>Ativo</MenuItem>
                      <MenuItem value={'INATIVO'}>Inativo</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
              </Box>
              {infosTerms.id && (
                <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200' }}>
                  <TabContext value={value} variant="scrollable" scrollButtons="auto">
                    <Box sx={{ mt: 3, p: 1 }}>
                      <TabList onChange={handleTabsChange} aria-label="VigenciasTabs">
                        <Tab label="Vigências" value="1" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <Stack direction="row" alignItems="center" justifyContent="end">
                        {!isMobile && (
                          <Grid container>
                            <Grid item>
                              <CustomInfosForm>
                                Vincular/Visualizar dias de vigências
                              </CustomInfosForm>
                            </Grid>
                          </Grid>
                        )}
                        {!isMobile && (
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ mb: 1 }}>
                            <Button
                              variant="contained"
                              onClick={termModalDay}
                              startIcon={<Iconify icon="eva:plus-fill" />}>
                              Novo
                            </Button>
                            <Button
                              variant="outlined"
                              onClick={getDaysTerms}
                              sx={{ ml: 1 }}
                              startIcon={<Iconify icon="eva:refresh-outline" />}>
                              Atualizar
                            </Button>
                          </Stack>
                        )}
                        {isMobile && (
                          <Grid item xs={12} sx={{ mb: 3 }}>
                            <Stack direction="row" alignItems="center" justifyContent="end">
                              <Button
                                variant="contained"
                                onClick={getDaysTerms}
                                startIcon={<Iconify icon="eva:plus-fill" />}>
                                Novo
                              </Button>
                            </Stack>
                          </Grid>
                        )}
                      </Stack>
                      <DataGrid
                        dataSource={infosDaysTerms}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        noDataText={'Não há dias de vigência vinculados'}>
                        <Column dataField="dia" caption="Dia de vigência" />
                        <Column dataField="dia_corte" caption="Dia de corte" />
                        <Column
                          dataField="Ações"
                          width={200}
                          allowSorting={false}
                          cellRender={(data) => <ActionsButtonsDayOfTerm data={data} />}
                        />
                        <SearchPanel visible={true} width={253} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={10} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                  </TabContext>
                </Box>
              )}
              <Stack direction="row" justifyContent="end" sx={{ mt: 5 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  color="success"
                  sx={{ mr: 2 }}
                  startIcon={<Iconify icon="eva:save-fill" />}>
                  {infosTerms.id ? 'Atualizar' : 'Salvar'}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  component={RouterLink}
                  to="/app/terms"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Cancelar
                </Button>
              </Stack>
            </form>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default addEditTerms;
